import { siteGeometryStore } from "../store";

export function removeSiteFeatureById(siteId: string) {
  siteGeometryStore.siteFeatures = siteGeometryStore.siteFeatures.filter(
    (feature) => feature.id !== siteId
  );
}
